"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SwitchToggle = function (_a) {
    var value = _a.value, name = _a.name, onToggle = _a.onToggle;
    return (react_1.default.createElement("div", { className: 'switch-toggle', "data-on": value, onClick: function () { return onToggle(name); } },
        react_1.default.createElement("div", { className: 'switch-toggle__rail' }, "\u00A0"),
        react_1.default.createElement("div", { className: 'switch-toggle__dot' }, "\u00A0")));
};
exports.default = SwitchToggle;
